export const dialogType = {
    color: 0,
    subdepartment: 1,
    cycleGoal: 2,
    message: 3,
    delete: 4,
};